export const makeOptionsApiRoutes = () => {
  const routes = {
    options: (orgId = ":orgId") => `/orgs/${orgId}/options`,
    userOptions: () => `/options`,
  }
  return routes
}
